export const PPARK1731_SP_ONE_CLICK = 'PPARK1731_SP_ONE_CLICK';
